import React from 'react';
import { Button } from 'antd';

interface ScheduleWarningFixNowButtonProps {
  onToggle: () => void;
  text: string;
}

const ScheduleWarningFixNowButton: React.FC<ScheduleWarningFixNowButtonProps> = ({ onToggle, text }) => (
  <Button key="warning-toggle" onClick={onToggle}>
    {text}
  </Button>
);

export default ScheduleWarningFixNowButton;
